import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import { ReportDialogs } from '../../constants/Dialogs';
import moment from 'moment';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from '../Common/TextField';
import { Form as FormsyForm } from 'formsy-react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TimePicker from '../Common/TimePicker';
import Chip from '../Common/Chip';

import DialogActions from '../../actions/DialogActionCreator';
import ReportActions from '../../actions/ReportActionCreator';
import DialogStore from '../../stores/DialogStore';
import ReportStore from '../../stores/ReportStore';


class ReportScheduleDialog extends Component {

    componentDidMount() {
        this.onReportsChange = this.onReportsChange.bind(this);
        this.onSave = this.onSave.bind(this);

        this.listener = ReportStore.addListener(this.onReportsChange);
        ReportActions.getAll();
    }

    componentWillUnmount() {
        this.listener.remove();
    }

    render() {
        if (this.state.open !== ReportDialogs.SCHEDULE_ADD && this.state.open !== ReportDialogs.SCHEDULE_EDIT) { return null; }
        const isEdit = this.state.open === ReportDialogs.SCHEDULE_EDIT;

        const dialogProps = {
            title: !isEdit ? 'Add schedule' : 'Edit schedule' ,
            open: true,
            modal: false,
            autoScrollBodyContent: true,
            onRequestClose: this.props.onClose,
            actions: [
                <FlatButton key="cancel" label="Cancel" onTouchTap={this.props.onCancel} />,
                <FlatButton
                    key="save"
                    label={!isEdit ? 'Save' : 'Edit'}
                    onTouchTap={this.onSave}
                    disabled={!this.state.draft.reportId}
                />
            ]
        };

        return (
            <Dialog {...dialogProps}>
                <FormsyForm>
                    <div className="cent-col-1">
                        <TextField
                            name="name"
                            value={this.state.draft.name}
                            validations="minLength:1,maxLength:80"
                            validationError="Please use only numbers and letters, at least 1"
                            hintText="Name"
                            fullWidth={true}
                            floatingLabelText="Name"
                            onChange={(e, value) => DialogActions.updateDraft('name', value)}
                            required
                        />
                        <SelectField
                            name="reportId"
                            value={this.state.draft.reportId}
                            floatingLabelText="Report"
                            onChange={({target}, index, value) => DialogActions.updateDraft('reportId', value)}
                            fullWidth
                        >
                            {this.state.reports.map(({id, name}) => <MenuItem key={id} value={id} primaryText={name} />)}
                        </SelectField>
                        <TimePicker
                            name="schedule"
                            floatingLabelText="Time"
                            value={this.state.draft.schedule}
                            onChange={(e, time) => DialogActions.updateDraft('schedule', time)}
                        />
                        <SelectField
                            name="repeatInterval"
                            value={this.state.draft.repeatInterval}
                            floatingLabelText="Repeat interval"
                            onChange={({target}, index, value) => DialogActions.updateDraft('repeatInterval', value)}
                            fullWidth
                        >
                            {this.getIntervalOptions()}
                        </SelectField>
                        <TextField
                            name="recipient"
                            value={this.state.draft.newRecipient}
                            validations="isEmail,maxLength:120"
                            validationError="Please enter a valid email address"
                            hintText="New recipient"
                            floatingLabelText="New recipient"
                            onChange={(e, value) => DialogActions.updateDraft('newRecipient', value)}
                            style={{width:'85%'}}
                        />
                        <FlatButton
                            label="add"
                            disabled={!this.state.draft.newRecipient}
                            style={{float: 'right', marginTop: 40}}
                            onTouchTap={() => {
                                const recipients = this.state.draft.recipients || [];
                                if (!recipients.includes(this.state.draft.newRecipient)) {
                                    DialogActions.updateDraft('recipients', [...recipients, this.state.draft.newRecipient]);
                                }
                                DialogActions.updateDraft('newRecipient', '');
                            }}
                        />
                        <div className="cent-form-chips">{this.getRecipientChips()}</div>
                    </div>
                </FormsyForm>
            </Dialog>
        );
    }

    onReportsChange() {
        const reports = ReportStore.getAll();
        if (!!reports) {
            this.setState({reports});
        }
    }

    onSave() {
        const data = {
            name: this.state.draft.name,
            schedule: moment(this.state.draft.schedule).format('HH:mm'),
            repeatInterval: this.state.draft.repeatInterval,
            recipients: this.state.draft.recipients
        }

        if (this.state.open === ReportDialogs.SCHEDULE_ADD) {
            ReportActions.addSchedule(this.state.draft.reportId, data);
        } else {
            data.reportId = this.state.draft.reportId;
            ReportActions.updateSchedule(this.state.draft.id, data);
        }

        if (this.props.closeOnSave) {
            this.props.onClose();
        }
    }

    getRecipientChips() {
        if (!this.state.draft.recipients) { return null; }

        return this.state.draft.recipients.map((recipient) => {
            const deleteAction = () => DialogActions.updateDraft('recipients', this.state.draft.recipients.filter((r) => r !== recipient));
            return (
                <Chip
                    key={recipient}
                    label={recipient}
                    onDelete={deleteAction}
                />
            );
        });
    }

    getIntervalOptions() {
        const startDate = !!this.state.draft.dateAdded ? moment(this.state.draft.dateAdded) : moment();
        return [
            <MenuItem key="day"   value="day"   primaryText="Daily"/>,
            <MenuItem key="week"  value="week"  primaryText={`Weekly on ${startDate.format('dddd')}`}/>,
            <MenuItem key="month" value="month" primaryText={`Monthly on the ${startDate.format('Do')}`}/>,
            <MenuItem key="year"  value="year"  primaryText={`Annually on the ${startDate.format('Do [of] MMMM')}`}/>
        ];
    }
}

ReportScheduleDialog.getStores = () => [DialogStore];
ReportScheduleDialog.calculateState = (prevState) => {
    const { open, draft } = DialogStore.getState();
    return {
        open,
        draft,
        reports: !!prevState && prevState.reports || []
    };
}
ReportScheduleDialog.propTypes = {
    onClose:        PropTypes.func,
    onCancel:       PropTypes.func,
    onSave:         PropTypes.func,
    closeOnSave:    PropTypes.bool
};
ReportScheduleDialog.defaultProps = {
    onClose:        DialogActions.close,
    onCancel:       DialogActions.close,
    onSave:         () => true,
    closeOnSave:    true
};

export default Container.create(ReportScheduleDialog);
